const { REGULATIONS_PAGE } = require('./routes')

// Search Invoice. This data is used in all invoices to create seller column:

const HOST = process.env.NEXT_PUBLIC_HOST

const Business = {
    owner: 'Samochody.pl Sp. z o.o.',
    ownerAlt: 'Samochody.pl Sp. z o.o.',
    logo: 'https://drive.google.com/uc?export=view&id=1ATFGGA43ZHT--pE-wiiYfTYQ84xD5Yh2',
    image: 'https://drive.google.com/uc?export=view&id=1CPkfZqKtmuTCULLF3xHWHUq4-GtCPBYu',
    firm: 'Samochody.pl Sp. z o.o.',
    nip: '9731074029',
    // regon: '380872518',
    name: 'Samochody.pl',
    www: 'https://samochody.pl/',
    email: 'kontakt@samochody.pl',
    phone: '+48 570 970 160',
    address: 'ul. Błotna 17\n65-133 Zielona Góra',
    host: HOST,
    hosting: 'kei',
    copyright: 'Copyright ©' + new Date().getFullYear() + '.',
    facebook: 'https://www.facebook.com/samochody.pl.ogloszenia/',
    twitter: 'https://twitter.com/samochody_pl',
    instagram: 'https://www.instagram.com/pl_samochody/',
    regulations: HOST + REGULATIONS_PAGE,
    invoice: {
        bdo: '000686600',
        firm: 'Samochody.pl Sp. z o.o.',
        address: 'ul. Błotna 17\n65-133 Zielona Góra',
        NIP: '9731074029'
    },
}

module.exports = Business